<span class="loading" *ngIf="loading">
  <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bar></app-side-menu-bar>
<div class="main-content">
    <!-- <div class="heading">
        <label class="heading-text">Quality Matrix Data - {{pickedyear}}</label>
    </div> -->
    <div class="filters" [formGroup]="incidentDataForm">
      <!-- Cluster -->
      <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select BU/GBU Sub-Region</mat-label>
        <mat-select [(ngModel)]="clusterdefault" formControlName="clusters" (selectionChange)="loadSite()">
          <mat-option *ngFor="let clus of cluster" [disabled]="disableCluster" [value]="clus">{{clus}}</mat-option>
        </mat-select>
      </mat-form-field>
      </div>
      <!-- Site -->
      <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Site</mat-label>
        <mat-select [(ngModel)]="sitedefault" formControlName="sites" (selectionChange)="loadBigCategory()">
          <mat-option *ngFor="let fact of sites" [disabled]="disableSite" [value]="fact">{{fact}}</mat-option>
        </mat-select>
      </mat-form-field>
      </div>
      <!-- Big Category -->
      <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Business Group</mat-label>
        <mat-select [(ngModel)]="bigcategorydefault" formControlName="bigcategories"
          (selectionChange)="ClearCurrencyOnBigCategorySelect()">
          <mat-option *ngFor="let categ of bigcategoryU" [value]="categ">{{categ}}</mat-option>
        </mat-select>
      </mat-form-field>
      </div>
      <!-- Currency -->
      <!--<div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Currency</mat-label>
        <mat-select [(ngModel)]="currencydefault" formControlName="currency" (selectionChange)="EnableGetDataButton()">
          <mat-option *ngFor="let curr of currencies" [value]="curr">{{curr}}</mat-option>
        </mat-select>
      </mat-form-field>
      </div> -->
      <!-- Year -->
      <div class="filtersDropdown">
        <!-- <p class="dropdownlabel">Year</p>
        <select formControlName="yearcontrol" (change)="clearData()">
          <option *ngFor="let year of yearSelect">{{year}}</option>
        </select> -->
        <mat-form-field appearance="fill" class="datepickerwidth">
          <mat-label>Select Year</mat-label>
          <mat-select formControlName="yearcontrol" (selectionChange)="clearData()">
            <mat-option *ngFor="let year of yearSelect" [value]="year">{{year}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Get IncidentData -->
      <div class="filtersDropdown">
        <button type="button" class="btn-qm" (click)="getQualityMatrixData()"> Get Data </button>
      </div>
    </div>
    <div>
      <div *ngIf="noRecordsShow" class="records">{{noRecords}}</div>
      <div class="incident-container mat-elevation-z8" [hidden]="noRecordsShow">
        <mat-paginator #paginator 
                [pageSize]="5"
                [pageSizeOptions]="[5, 10, 20,30]"
                showFirstLastButtons 
                aria-label="Select page of dataSource">
        </mat-paginator>
        <table mat-table [dataSource]="dataSource" >
          <!-- Production Date Column -->
          <ng-container matColumnDef="productiondate">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Production Date </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.productiondate}} </td>
          </ng-container>
          <!-- Production Code Column -->
          <ng-container matColumnDef="productcode">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Product Code </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element">
              <span>{{element.productcode}}</span>
            </td>
          </ng-container>
          <!-- Production Description Column -->
          <ng-container matColumnDef="productdescription">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Product Description </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element">
              <span> {{element.productdescription}} </span>
            </td>
          </ng-container>
          <!-- Material Type Column -->
          <ng-container matColumnDef="MaterialType">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Material Type </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span> {{element.materialtype}} </span>
            </td>
          </ng-container>
          <!-- Defect Mode Aggregation Column -->
          <ng-container matColumnDef="defectmodeaggregation">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Defect Mode Aggregation </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.defectmodeaggregation}}</span>
            </td>
          </ng-container>
          <!-- Packaging Material Level Column -->
          <ng-container matColumnDef="PackaginMaterialLevel">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Packaging Material Level </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span> {{element.packagingmateriallevel}} </span>
            </td>
          </ng-container>
          <!-- Category Column -->
          <ng-container matColumnDef="bigcategory">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Category </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.bigcategory}}</span>
            </td>
          </ng-container>
          <!-- Sub Category Column -->
          <ng-container matColumnDef="subcategory">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Sub Category </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.subcategory}}</span>
            </td>
          </ng-container>
          <!-- Product Column -->
          <!--<ng-container matColumnDef="product">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Product </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.product}}</span>
            </td>
          </ng-container> -->
          <!-- Product Column -->
          <ng-container matColumnDef="recordid">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> RecordID </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.recordid}}</span>
            </td>
          </ng-container>
          <!-- Defect Type Code Column -->
          <ng-container matColumnDef="defecttypecode">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Defect Type Code </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.defecttypecode}}</span>
            </td>
          </ng-container>
          <!-- LossTree Column -->
          <ng-container matColumnDef="losstree">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Loss Tree </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.losstree}}</span>
            </td>
          </ng-container>
          <!-- Level0 Column -->
          <ng-container matColumnDef="leveL0">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Level0 </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.leveL0}}</span>
            </td>
          </ng-container>
          <!-- Level1 Column -->
          <ng-container matColumnDef="leveL1">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Level1 </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.leveL1}}</span>
            </td>
          </ng-container>
          <!-- Level2 Column -->
          <ng-container matColumnDef="leveL2">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Level2 </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.leveL2}}</span>
            </td>
          </ng-container>
          <!-- Level3 Column -->
          <ng-container matColumnDef="leveL3">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Level3 </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.leveL3}}</span>
            </td>
          </ng-container>
          <!-- Level4 Column -->
          <ng-container matColumnDef="leveL4">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Level4 </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.leveL4}}</span>
            </td>
          </ng-container>
          <!-- Level5 Column -->
          <ng-container matColumnDef="leveL5">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Level5 </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.leveL5}}</span>
            </td>
          </ng-container>
          <!-- DefectSeverityGrade Column -->
          <ng-container matColumnDef="defectseveritygrade">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Defect Severity Grade </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.defectseveritygrade}}</span>
            </td>
          </ng-container>
          <!-- ProductionLine Column -->
          <ng-container matColumnDef="productionline">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Production Line </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.productionline}}</span>
            </td>
          </ng-container>
          <!-- No of blocked Product Column -->
          <ng-container matColumnDef="noofblockedproduct">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> No of Blocked Product </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.noofblockedproduct}}</span>
            </td>
          </ng-container>
          <!-- AverageBatchQty Column -->
          <ng-container matColumnDef="averagebatchqty">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Average Batch Quantity </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.averagebatchqty}}</span>
            </td>
          </ng-container>
          <!-- UoM Column -->
          <ng-container matColumnDef="uom">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> UoM </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.uom}}</span>
            </td>
          </ng-container>
          <!-- Affectedproductpercentage Column -->
          <ng-container matColumnDef="affectedproductpercentage">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> % of Affected Product </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.affectedproductpercentage}}</span>
            </td>
          </ng-container>
          <!-- frequencyscore Column -->
          <ng-container matColumnDef="frequencyscore">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Frequency Score </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.frequencyscore}}</span>
            </td>
          </ng-container>
          <!-- processpoint Column -->
          <ng-container matColumnDef="processpoint">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Process Point </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.processpoint}}</span>
            </td>
          </ng-container>
          <!-- 4Ms Column -->
          <ng-container matColumnDef="fourms">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> 4Ms </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.fourms}}</span>
            </td>
          </ng-container>
          <!-- detectionpoint Column -->
          <ng-container matColumnDef="detectionpoint">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> DetectionPoint </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.detectionpoint}}</span>
            </td>
          </ng-container>
          <!-- detectability Column -->
          <ng-container matColumnDef="detectability">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Detectability </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.detectability}}</span>
            </td>
          </ng-container>
          <!-- eincident Column -->
          <ng-container matColumnDef="eincident">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> E-Incidents </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.eincident}}</span>
            </td>
          </ng-container>
          <!-- rework Column -->
          <ng-container matColumnDef="rework">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Rework </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.rework}}</span>
            </td>
          </ng-container>
          <!-- ambercrqs Column -->
          <ng-container matColumnDef="ambercrqs">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Amber CRQS </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.ambercrqs}}</span>
            </td>
          </ng-container>
          <!-- qualityrelatedwaste Column -->
          <ng-container matColumnDef="qualityrelatedwaste">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Quality Related </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.qualityrelatedwaste}}</span>
            </td>
          </ng-container>
          <!-- dincidents Column -->
          <ng-container matColumnDef="dincidents">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> D-Incidents </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.dincidents}}</span>
            </td>
          </ng-container>
          <!-- palletnonconformance Column -->
          <ng-container matColumnDef="palletnonconformance">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Pallet Non-Conformance </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.palletnonconformance}}</span>
            </td>
          </ng-container>
          <!-- customernonconformance Column -->
          <ng-container matColumnDef="customernonconformance">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Customer Non-Conformance </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.customernonconformance}}</span>
            </td>
          </ng-container>
          <!-- onshelfcrqs Column -->
          <ng-container matColumnDef="onshelfcrqs">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> On-Shelf CRQS </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.onshelfcrqs}}</span>
            </td>
          </ng-container>
          <!-- consumercomplaints Column -->
          <ng-container matColumnDef="consumercomplaints">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Consumer Complaints </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.consumercomplaints}}</span>
            </td>
          </ng-container>
          <!-- marketplaceincident Column -->
          <ng-container matColumnDef="marketplaceincident">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Market Place Incident </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.marketplaceincident}}</span>
            </td>
          </ng-container>
          <!-- costoF1PC Column -->
          <ng-container matColumnDef="costoF1PC">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Unit of Cost </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.costoF1PC}}</span>
            </td>
          </ng-container>
          <!-- totaldefectcost Column -->
          <ng-container matColumnDef="totaldefectcost">
            <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Total Defect Dost </th>
            <td class="rightDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.totaldefectcost}}</span>
            </td>
          </ng-container>
          <!-- totalcostpercentage Column -->
          <ng-container matColumnDef="totalcostpercentage">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> % of Totalcost </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.totalcostpercentage}}</span>
            </td>
          </ng-container>
          <!-- costscore Column -->
          <ng-container matColumnDef="costscore">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Cost Score </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.costscore}}</span>
            </td>
          </ng-container>
          <!-- detectabilityindex Column -->
          <ng-container matColumnDef="detectabilityindex">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Detectability Index </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.detectabilityindex}}</span>
            </td>
          </ng-container>
          <!-- severityindex Column -->
          <ng-container matColumnDef="severityindex">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Severity Index </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.severityindex}}</span>
            </td>
          </ng-container>
          <!-- frequencyindex Column -->
          <ng-container matColumnDef="frequencyindex">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Frequency Index </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.frequencyindex}}</span>
            </td>
          </ng-container>
          <!-- costindex Column -->
          <ng-container matColumnDef="costindex">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Cost Index </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.costindex}}</span>
            </td>
          </ng-container>
          <!-- defectpriorityindex Column -->
          <ng-container matColumnDef="defectpriorityindex">
            <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Defect Priority Index </th>
            <td class="rightDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.defectpriorityindex | number}}</span>
            </td>
          </ng-container>
          <!-- pdcastatus Column -->
          <ng-container matColumnDef="pdcastatus">
            <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> PDCA Status </th>
            <td class="rightDataCell" mat-cell *matCellDef="let element"> 
              <span>{{element.pdcastatus}}</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="incidentDataCol;sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: incidentDataCol;"></tr>
        </table>
      </div>
    </div>
</div>
